import { apiClient } from "./ApiClient";

const CHALLENGE_API_URL = `${process.env.VUE_APP_API_BASE_URL}/api/v1/challenges`;

export default {
  list({ page, page_size, sort, order, section_id = -1, search_term, platoon_id = -1 }) {
    return apiClient.get(
      `${CHALLENGE_API_URL}?page=${page}&page_size=${page_size}&sort=${sort}&order=${order}&section_id=${section_id}&search_term=${search_term}&platoon_id=${platoon_id}`
    );
  },
  add({
    title,
    description,    
    venue,
    platoon_id,
    section_id,
    community_id,
    start_time, 
    end_time,
    duration,
    userIds,
  }) {
    return apiClient.post(`${CHALLENGE_API_URL}/`, {
        title,
        description,    
        venue,
        platoon_id,
        section_id,
        community_id,
        start_time, 
        end_time,
        duration,
        userIds,
    });
  },
  edit({
    challenge_id,
    title,
    description,    
    venue,
    platoon_id,
    section_id,
    community_id,
    start_time, 
    end_time,
  }) {
    return apiClient.put(`${CHALLENGE_API_URL}/`, {
        challenge_id,
        title,
        description,    
        venue,
        platoon_id,
        section_id,
        community_id,
        start_time, 
        end_time,
    });
  },
  delete(challenge_id) {
    console.log("Deleting challenge with ID:", challenge_id);
    return apiClient.delete(`${CHALLENGE_API_URL}/`, { data: {challenge_id} });
  },
  fetchChallengeDetails(challengeReq) {
    return apiClient.get(`${CHALLENGE_API_URL}/`+challengeReq.challenge_id);
  },
  stop({ challenge_id }) {
    return apiClient.post(`${CHALLENGE_API_URL}/stop`, {challenge_id});
  },
  saveChallengeResults(challengeResults) {
    console.log("Saving challenge results for ID:", challengeResults.challenge_id);
    return apiClient.post(`${CHALLENGE_API_URL}/results`, challengeResults);
  },
  fetchResults(challenge_id) {
    console.log("Fetching challenge results for ID:", challenge_id);
    return apiClient.get(`${CHALLENGE_API_URL}/results/`+challenge_id);
  },
  reStartChallenge(challengeRequest) {
    console.log("Re-starting challenge with ID:", challengeRequest.challenge_id);
    return apiClient.post(`${CHALLENGE_API_URL}/restart`, challengeRequest);
  },
};
